export const agentJobResources = {
  fr: {
    status: { blocked: 'Bloqué', unknown: 'Inconnu', queued: 'En file', running: 'En cours', completed: 'Terminé', succeeded: 'Réussi', failed: 'Échec', cancelled: 'Annulé', expired: 'Expiré' },
    recoveryEvidence: 'État durable pour la reprise', revision: 'Révision enregistrée', runtimeExecution: 'Exécution liée', leaseDeadline: 'Expiration du lease',
    title: 'Activité Agent', description: 'Travaux durables dans l’Application courante.', overview: 'Vue d’ensemble',
    empty: 'Aucun job pour cette Application.',
    select: 'Sélectionnez un job pour voir ses preuves.',
    loading: 'Chargement des jobs…',
    detailLoading: 'Chargement du détail…',
    error: 'Impossible de charger les jobs.',
    inaccessible: 'Cette Application n’est pas disponible dans le contexte courant.',
    goal: 'Objectif',
    statusLabel: 'État',
    workflow: 'Workflow',
    version: 'Version',
    created: 'Créé',
    attempts: 'Tentatives',
    owner: 'Provenance',
    agentSpec: 'Agent Spec',
    workflowSource: 'Workflow publié',
    runtime: 'Runtime',
    stopStatus: 'Arrêt runtime',
    stopRequested: 'Arrêt demandé',
    stopConfirmed: 'Arrêt confirmé',
    stopUnknown: 'Arrêt inconnu',
    stopNotRequested: 'Aucun arrêt demandé',
    cancel: 'Annuler le job',
    cancelling: 'Annulation…',
    retry: 'Relancer',
    retrying: 'Relance…',
    retryBlocked: 'Relance bloquée : l’état d’un effet reste inconnu.',
    result: 'Résultat',
    noResult: 'Aucun résultat durable.',
    artifacts: 'Artefacts', artifactRef: 'Référence', artifactSha256: 'SHA-256',
    noArtifacts: 'Aucun artefact.',
    events: 'Événements',
    noEvents: 'Aucun événement durable.',
    cost: 'Coût (unités mineures)',
    costPending: 'Coût en cours de consolidation.',
    costUnknown: 'Coût indisponible.',
    errorDetail: 'Erreur runtime',
    retryOf: 'Relance de',
    unknown: 'Inconnu',
    blockedReason: 'Motif du blocage', blockedReasonEffectOutcomeUnknown: 'Effet non confirmé ; aucune relance automatique.', blockedReasonPermissionRevoked: 'Autorisation révoquée.', blockedReasonLeaseLost: 'Lease perdue.', blockedReasonCostUnknown: 'Coût inconnu.', blockedReasonBudgetExceeded: 'Budget dépassé.', blockedReasonValidationFailed: 'Validation du résultat échouée.', blockedReasonUnknown: 'Motif de blocage inconnu ({code}).',
    hardDeadline: 'Échéance',
    lease: 'Lease runtime',
    principalId: 'Identité technique',
    specHash: 'Empreinte Agent Spec',
    invalidResult: 'Résultat non validé par le contrat.',
    launchTitle: 'Lancer un Workflow publié', selectWorkflow: 'Choisissez un Workflow', inputs: 'Entrées JSON', launch: 'Lancer', launching: 'Lancement…', launchInvalid: 'Workflow ou objectif invalide.', launchInvalidJson: 'Les entrées doivent être un objet JSON valide.',
    graph: {
      title: 'Plans d’exécution',
      listTitle: 'Plans',
      listEmpty: 'Aucun plan d’exécution pour cette Application.',
      orgListTitle: 'Plans de l’organisation',
      orgListEmpty: 'Aucun plan de portée organisation.',
      scopeOrganization: 'Portée organisation',
      loading: 'Chargement des plans…',
      error: 'Impossible de charger les plans d’exécution.',
      select: 'Sélectionnez un plan pour voir ses phases et ses nœuds.',
      detailLoading: 'Chargement du plan…',
      detailError: 'Impossible de charger ce plan.',
      phasesProgress: '{{ended}}/{{total}} phases terminées',
      nodesProgress: '{{done}}/{{total}} nœuds terminés',
      phases: 'Phases',
      phasesEmpty: 'Aucune phase dans ce plan.',
      phaseStatus: { pending: 'À venir', running: 'En cours', completed: 'Terminée' },
      nodes: 'Nœuds',
      nodesEmpty: 'Aucun nœud dans cette phase.',
      nodeStatus: { pending: 'En attente', active: 'Actif', completed: 'Terminé', failed: 'Échec', cancelled: 'Annulé', expired: 'Expiré', skipped: 'Ignoré', blocked: 'Bloqué' },
      status: { validated: 'Prêt à lancer', running: 'En cours', blocked: 'Bloqué', completed: 'Terminé', failed: 'Échec', cancelled: 'Annulé' },
      cost: 'Coût cumulé (unités mineures)',
      budget: 'Budget maximal',
      deadline: 'Échéance',
      noDeadline: 'Pas d’échéance avant le lancement.',
      noJob: 'Aucun job créé pour ce nœud.',
      openJob: 'Ouvrir le job',
      failureCode: 'Code d’échec',
      jobStatus: 'État du job',
      cancelRequested: 'Annulation demandée',
      cancel: 'Annuler le plan',
      cancelling: 'Annulation…',
      launch: 'Lancer',
      launching: 'Lancement…',
      launchHint: 'Le lancement démarre le plan avec son budget et son échéance.',
      conflict: 'Le plan a changé depuis votre lecture. Il est actualisé ; relancez l’action si nécessaire.',
      actionError: 'L’action sur le plan a échoué.',
      blockedReasonDeadlineExceeded: 'Échéance dépassée.',
      blockedReasonNodeBlocked: 'Un nœud du plan est bloqué.',
    },
  },
  en: {
    status: { blocked: 'Blocked', unknown: 'Unknown', queued: 'Queued', running: 'Running', completed: 'Completed', succeeded: 'Succeeded', failed: 'Failed', cancelled: 'Cancelled', expired: 'Expired' },
    recoveryEvidence: 'Durable recovery evidence', revision: 'Recorded revision', runtimeExecution: 'Linked execution', leaseDeadline: 'Lease deadline',
    title: 'Agent activity', description: 'Durable work in the current Application.', overview: 'Overview',
    empty: 'No jobs for this Application.',
    select: 'Select a job to inspect its evidence.',
    loading: 'Loading jobs…',
    detailLoading: 'Loading details…',
    error: 'Unable to load jobs.',
    inaccessible: 'This Application is unavailable in the current context.',
    goal: 'Goal',
    statusLabel: 'Status',
    workflow: 'Workflow',
    version: 'Version',
    created: 'Created',
    attempts: 'Attempts',
    owner: 'Provenance',
    agentSpec: 'Agent Spec',
    workflowSource: 'Published Workflow',
    runtime: 'Runtime',
    stopStatus: 'Runtime stop',
    stopRequested: 'Stop requested',
    stopConfirmed: 'Stop confirmed',
    stopUnknown: 'Stop unknown',
    stopNotRequested: 'No stop requested',
    cancel: 'Cancel job',
    cancelling: 'Cancelling…',
    retry: 'Retry',
    retrying: 'Retrying…',
    retryBlocked: 'Retry blocked: an effect remains in an unknown state.',
    result: 'Result',
    noResult: 'No durable result.',
    artifacts: 'Artifacts', artifactRef: 'Reference', artifactSha256: 'SHA-256',
    noArtifacts: 'No artifacts.',
    events: 'Events',
    noEvents: 'No durable events.',
    cost: 'Cost (minor units)',
    costPending: 'Cost is still being consolidated.',
    costUnknown: 'Cost unavailable.',
    errorDetail: 'Runtime error',
    retryOf: 'Retry of',
    unknown: 'Unknown',
    blockedReason: 'Block reason', blockedReasonEffectOutcomeUnknown: 'Effect outcome was not confirmed; no automatic replay.', blockedReasonPermissionRevoked: 'Permission revoked.', blockedReasonLeaseLost: 'Lease lost.', blockedReasonCostUnknown: 'Cost unknown.', blockedReasonBudgetExceeded: 'Budget exceeded.', blockedReasonValidationFailed: 'Result validation failed.', blockedReasonUnknown: 'Unknown block reason ({code}).',
    hardDeadline: 'Deadline',
    lease: 'Runtime lease',
    principalId: 'Technical identity',
    specHash: 'Agent Spec fingerprint',
    invalidResult: 'Result did not pass its contract validation.',
    launchTitle: 'Run a published Workflow', selectWorkflow: 'Choose a Workflow', inputs: 'JSON inputs', launch: 'Run', launching: 'Starting…', launchInvalid: 'Workflow or goal is invalid.', launchInvalidJson: 'Inputs must be a valid JSON object.',
    graph: {
      title: 'Execution plans',
      listTitle: 'Plans',
      listEmpty: 'No execution plan for this Application.',
      orgListTitle: 'Organization plans',
      orgListEmpty: 'No organization-scoped plan.',
      scopeOrganization: 'Organization scope',
      loading: 'Loading plans…',
      error: 'Unable to load execution plans.',
      select: 'Select a plan to see its phases and nodes.',
      detailLoading: 'Loading plan…',
      detailError: 'Unable to load this plan.',
      phasesProgress: '{{ended}}/{{total}} phases completed',
      nodesProgress: '{{done}}/{{total}} nodes completed',
      phases: 'Phases',
      phasesEmpty: 'No phase in this plan.',
      phaseStatus: { pending: 'Upcoming', running: 'Running', completed: 'Completed' },
      nodes: 'Nodes',
      nodesEmpty: 'No node in this phase.',
      nodeStatus: { pending: 'Pending', active: 'Active', completed: 'Completed', failed: 'Failed', cancelled: 'Cancelled', expired: 'Expired', skipped: 'Skipped', blocked: 'Blocked' },
      status: { validated: 'Ready to launch', running: 'Running', blocked: 'Blocked', completed: 'Completed', failed: 'Failed', cancelled: 'Cancelled' },
      cost: 'Cumulative cost (minor units)',
      budget: 'Maximum budget',
      deadline: 'Deadline',
      noDeadline: 'No deadline before launch.',
      noJob: 'No job created for this node.',
      openJob: 'Open job',
      failureCode: 'Failure code',
      jobStatus: 'Job status',
      cancelRequested: 'Cancellation requested',
      cancel: 'Cancel plan',
      cancelling: 'Cancelling…',
      launch: 'Launch',
      launching: 'Launching…',
      launchHint: 'Launching starts the plan with its budget and deadline.',
      conflict: 'The plan changed since you read it. It has been refreshed; run the action again if needed.',
      actionError: 'The plan action failed.',
      blockedReasonDeadlineExceeded: 'Deadline exceeded.',
      blockedReasonNodeBlocked: 'A node in the plan is blocked.',
    },
  },
  es: {
    recoveryEvidence: 'Prueba durable de recuperación', revision: 'Revisión guardada', runtimeExecution: 'Ejecución vinculada', leaseDeadline: 'Caducidad del lease',
    title: 'Actividad del agente', description: 'Trabajos duraderos en la Application actual.', overview: 'Vista general',
    empty: 'No hay jobs para esta Application.',
    select: 'Selecciona un job para inspeccionar sus pruebas.',
    loading: 'Cargando jobs…',
    detailLoading: 'Cargando detalle…',
    error: 'No se pudieron cargar los jobs.',
    inaccessible: 'Esta Application no está disponible en el contexto actual.',
    goal: 'Objetivo', statusLabel: 'Estado', status: { queued: 'En cola', running: 'En curso', blocked: 'Bloqueado', completed: 'Completado', succeeded: 'Exitoso', failed: 'Fallido', cancelled: 'Cancelado', expired: 'Expirado', unknown: 'Desconocido' }, workflow: 'Workflow', version: 'Versión', created: 'Creado',
    attempts: 'Intentos', owner: 'Proveniencia', agentSpec: 'Agent Spec', workflowSource: 'Workflow publicado', blockedReasonEffectOutcomeUnknown: 'Efecto no confirmado; no se repite automáticamente.', blockedReasonPermissionRevoked: 'Permiso revocado.', blockedReasonLeaseLost: 'Lease perdida.', blockedReasonCostUnknown: 'Coste desconocido.', blockedReasonBudgetExceeded: 'Presupuesto excedido.', blockedReasonValidationFailed: 'Falló la validación del resultado.', blockedReasonUnknown: 'Motivo de bloqueo desconocido ({code}).',
    runtime: 'Runtime', stopStatus: 'Parada del runtime', stopRequested: 'Parada solicitada', stopConfirmed: 'Parada confirmada', stopUnknown: 'Parada desconocida', stopNotRequested: 'Sin parada solicitada',
    cancel: 'Cancelar job', cancelling: 'Cancelando…', retry: 'Reintentar', retrying: 'Reintentando…', retryBlocked: 'Reintento bloqueado: un efecto tiene estado desconocido.',
    result: 'Resultado', noResult: 'Sin resultado durable.', artifacts: 'Artefactos', artifactRef: 'Referencia', artifactSha256: 'SHA-256', noArtifacts: 'Sin artefactos.', events: 'Eventos', noEvents: 'Sin eventos durables.', cost: 'Coste (unidades menores)', costPending: 'El coste aún se está consolidando.', costUnknown: 'Coste no disponible.', errorDetail: 'Error de runtime', retryOf: 'Reintento de', unknown: 'Desconocido', blockedReason: 'Motivo del bloqueo', hardDeadline: 'Fecha límite', lease: 'Lease del runtime', principalId: 'Identidad técnica', specHash: 'Huella del Agent Spec', invalidResult: 'El resultado no pasó la validación del contrato.',
    launchTitle: 'Ejecutar un Workflow publicado', selectWorkflow: 'Elige un Workflow', inputs: 'Entradas JSON', launch: 'Ejecutar', launching: 'Iniciando…', launchInvalid: 'Workflow u objetivo no válidos.', launchInvalidJson: 'Las entradas deben ser un objeto JSON válido.',
    graph: {
      title: 'Planes de ejecución',
      listTitle: 'Planes',
      listEmpty: 'No hay ningún plan de ejecución para esta Application.',
      orgListTitle: 'Planes de la organización',
      orgListEmpty: 'No hay ningún plan de alcance organización.',
      scopeOrganization: 'Alcance organización',
      loading: 'Cargando planes…',
      error: 'No se pudieron cargar los planes de ejecución.',
      select: 'Selecciona un plan para ver sus fases y nodos.',
      detailLoading: 'Cargando plan…',
      detailError: 'No se pudo cargar este plan.',
      phasesProgress: '{{ended}}/{{total}} fases terminadas',
      nodesProgress: '{{done}}/{{total}} nodos terminados',
      phases: 'Fases',
      phasesEmpty: 'No hay fases en este plan.',
      phaseStatus: { pending: 'Pendiente', running: 'En curso', completed: 'Terminada' },
      nodes: 'Nodos',
      nodesEmpty: 'No hay nodos en esta fase.',
      nodeStatus: { pending: 'En espera', active: 'Activo', completed: 'Terminado', failed: 'Fallido', cancelled: 'Cancelado', expired: 'Expirado', skipped: 'Omitido', blocked: 'Bloqueado' },
      status: { validated: 'Listo para lanzar', running: 'En curso', blocked: 'Bloqueado', completed: 'Terminado', failed: 'Fallido', cancelled: 'Cancelado' },
      cost: 'Coste acumulado (unidades menores)',
      budget: 'Presupuesto máximo',
      deadline: 'Fecha límite',
      noDeadline: 'Sin fecha límite antes del lanzamiento.',
      noJob: 'No se ha creado ningún job para este nodo.',
      openJob: 'Abrir el job',
      failureCode: 'Código de fallo',
      jobStatus: 'Estado del job',
      cancelRequested: 'Cancelación solicitada',
      cancel: 'Cancelar el plan',
      cancelling: 'Cancelando…',
      launch: 'Lanzar',
      launching: 'Lanzando…',
      launchHint: 'El lanzamiento inicia el plan con su presupuesto y su fecha límite.',
      conflict: 'El plan cambió desde tu lectura. Se ha actualizado; vuelve a ejecutar la acción si hace falta.',
      actionError: 'La acción sobre el plan ha fallado.',
      blockedReasonDeadlineExceeded: 'Fecha límite superada.',
      blockedReasonNodeBlocked: 'Un nodo del plan está bloqueado.',
    },
  },
} as const
